import { FC } from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getAllUsers, getAllRoles } from '@/libs/fleet-api/services/admin';
import FleetTitle from '@/libs/antd/components/Title';

const AdminDashboardPage: FC = () => {
	const { data: users, isLoading: usersLoading } = useQuery({
		queryKey: ['admin-users'],
		queryFn: getAllUsers,
	});

	const { data: roles, isLoading: rolesLoading } = useQuery({
		queryKey: ['admin-roles'],
		queryFn: getAllRoles,
	});

	const activeUsers = users?.data?.filter((user) => user.isActive).length || 0;
	const totalUsers = users?.data?.length || 0;

	return (
		<div style={{ width: '100%' }}>
			<FleetTitle level={1}>Dashboard Admin</FleetTitle>

			<Row
				gutter={[24, 24]}
				style={{ marginTop: '24px' }}
			>
				<Col
					xs={24}
					sm={12}
					md={8}
				>
					<Card>
						<Statistic
							title="Total Pengguna"
							value={totalUsers}
							loading={usersLoading}
						/>
					</Card>
				</Col>
				<Col
					xs={24}
					sm={12}
					md={8}
				>
					<Card>
						<Statistic
							title="Pengguna Aktif"
							value={activeUsers}
							loading={usersLoading}
						/>
					</Card>
				</Col>
				<Col
					xs={24}
					sm={12}
					md={8}
				>
					<Card>
						<Statistic
							title="Total Role"
							value={roles?.data?.length || 0}
							loading={rolesLoading}
						/>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default AdminDashboardPage;
